import $ from 'jquery';
import 'remodal';

export default class {
  constructor($target) {
    this.$target = $target;
    this.bind();
  }

  bind() {
    $('#commonMenuBar').load('../parts/menuBar.html .commonMenuBar');
    $('#commonAdminHeader').load('../parts/headerAdmin.html header');
    $('#commonPublicHeader').load('../parts/headerPublic.html header');
    $('#commonAside').load('../parts/sideBar.html aside');
    $('#commonFooter').load('../parts/footer.html footer');

    this.$target.on('click', '.js-openRemodal', ((e) => {
      const $target = $(e.currentTarget);
      $(`[data-remodal-id=${$target.attr('id')} ]`).remodal().open();
    }));

    this.$target.on('click', '.js-confirm', ((e) => {
      $('.adminsForm input').prop('disabled', true);
      $('.adminsForm textarea').prop('disabled', true);
      $('.adminsForm select').prop('disabled', true);
      $('.adminsForm .default').hide();
      $('.adminsForm .confirm').css('display', 'flex');
    }));

    this.$target.on('click', '.js-cancel', ((e) => {
      $('.adminsForm input').prop('disabled', false);
      $('.adminsForm textarea').prop('disabled', false);
      $('.adminsForm select').prop('disabled', false);
      $('.adminsForm .default').css('display', 'flex');
      $('.adminsForm .confirm').hide();
    }));

    this.$target.on('click', '.js-execution', ((e) => {
      $('.adminsForm input').prop('disabled', false);
      $('.adminsForm textarea').prop('disabled', false);
      $('.adminsForm select').prop('disabled', false);
      $('.adminsForm .default').css('display', 'flex');
      $('.adminsForm .confirm').hide();
    }));

    this.$target.on('click', '.menubtn', ((e) => {
      $('.spmenu').addClass('menuopen');
      $('.spmenubg').addClass('menuopen');
    }));

    this.$target.on('click', '.spmenubg', ((e) => {
      $('.spmenu').removeClass('menuopen');
      $('.spmenubg').removeClass('menuopen');
    }));

    this.$target.on('click', '.menuclose', ((e) => {
      $('.spmenu').removeClass('menuopen');
      $('.spmenubg').removeClass('menuopen');
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/appComponent/index.js